// extracted by mini-css-extract-plugin
module.exports = {"ecList":"Accordion_ecList__3dlXg","ecItem":"Accordion_ecItem__s7_Ry","showScale":"Accordion_showScale__kd8Nq"};